export const scales = [
  { name: "Tablet", value: "tablet" },
  { name: "Capsule", value: "capsule" },
  { name: "Bottle", value: "bottle" },
  { name: "Tube", value: "tube" },
  { name: "gram", value: "g" },
  { name: "milli liter", value: "ml" },
  { name: "meter", value: "m" },
  { name: "unit", value: "u" },
];

/** Display name for a scale / drug form value ("capsule" → "Capsule"). */
export const scaleLabel = (value?: string): string =>
  scales.find((s) => s.value === value)?.name || value || "";

/**
 * Drug strength units. Printed straight after the dose ("500mg"), so they
 * are not the same thing as `scales`, which a drug uses as its Form.
 */
export const strengthUnits = [
  { name: "mg", value: "mg" },
  { name: "g", value: "g" },
  { name: "mcg", value: "mcg" },
  { name: "ml", value: "ml" },
  { name: "%", value: "%" },
  { name: "IU", value: "IU" },
];
